// Выход из игрового мира «назад к крикету»: на вкладку «Матчи» (кнопка «Игра» живёт в её шапке),
// нет такой вкладки в конфиге — на вкладку по умолчанию. Отдельный маленький модуль: его зовёт и Shell
// (системная «Назад» Telegram), и сам мир (кнопка exit_title), а экран мира грузится лениво.
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../api/queries';

export function useExitWorld(): () => void {
  const navigate = useNavigate();
  const items = useConfig().data?.navigation?.tab_bar?.items;
  const hasMatches = Boolean(items?.some((i) => i.key === 'matches'));
  return useCallback(() => navigate(hasMatches ? '/tab/matches' : '/', { replace: true }), [navigate, hasMatches]);
}
